export enum LinkType {
  EXTERNAL = 'external',
  CONTENT = 'content'
}
